<template>
  <span>
    <!-- keyed by route: Files and Finance share this component, so switching
         between them must rebuild the view rather than reuse its state -->
    <DocList v-if="defaultView" :key="`list-${$route.name}`"></DocList>
    <FileExplorer v-else :key="`explorer-${$route.name}`"></FileExplorer>
  </span>
</template>
<script>
import DocList from '@/views/docList.vue'
import FileExplorer from '@/views/FileExplorer.vue'
import { userAccess } from '@/mixins/user-access';

export default {
  name: 'FilesView',
  components: { DocList, FileExplorer },
  computed: {
    defaultView() {
      return this.$store.getters.showDefaultView;
    },
    preferredView() {
      return localStorage.getItem('preferredFileView')
    }
  },
  mixins: [userAccess],
  created() {
    // Finance only exists for tenants that have finance subcategories configured.
    if (this.docSection === 'finance' && !this.hasFinanceSection) {
      this.$router.replace({ name: 'Current' })
    }
  },
  mounted() {
    if (this.preferredView) {
      this.$store.commit('setShowDefaultView', this.preferredView === 'table')
    } else {
      this.$store.commit('setShowDefaultView', this.defaultFileView === 'table')
    }

  }
}
</script>